import React, { useState } from 'react';
import { TextField, Grid, makeStyles, MenuItem, Select, InputLabel, FormControl, Button } from '@material-ui/core';
import { useDebounced } from '../../hooks';
import { StringFilterInput } from '../../utils/types';

const useStyles = makeStyles((theme) => ({
	filter: {
		marginBottom: theme.spacing(2)
	},
	select: {
		minWidth: '140px'
	},
	clearButtom: {
		marginTop: theme.spacing(1)
	}
}));

const AiringFilters: React.FC<AiringsFiltersProps> = (props) => {
	const { setGraphQLFilters } = props;
	const [filters, setFilters] = useState<AiringFilters>({});
	const classes = useStyles();

	const generateGraphQLFilters = (): void => {
		const filterObject: AiringFiltersInput = {};
		if (filters?.filterGameId) filterObject.gameId = { beginsWith: filters.filterGameId };
		if (filters?.filterStatus) filterObject.status = { eq: filters.filterStatus };
		if (filters?.filterStartDate) filterObject.startTime = { beginsWith: filters.filterStartDate };
		if (filters?.filterStartDate && filters?.filterUntilDate) {
			filterObject.startTime = {
				between: [`${filters.filterStartDate}T00:00:00.000Z`, `${filters.filterUntilDate}T23:59:59.999Z`]
			};
		}
		setGraphQLFilters(filterObject);
	};

	useDebounced(() => generateGraphQLFilters(), 400, [filters]);

	const onChangeFilter = (field: keyof AiringFilters, value: string): void => {
		const newFilters: AiringFilters = { ...filters };
		newFilters[field] = value;
		setFilters(newFilters);
	};

	return (
		<Grid container spacing={2} className={classes.filter}>
			<Grid item>
				<TextField
					id='gameId'
					label='Game Id'
					name='gameid'
					value={filters.filterGameId ?? ''}
					onChange={(e): void => onChangeFilter('filterGameId', e.target.value)}
					variant='outlined'
				/>
			</Grid>
			<Grid item>
				<FormControl variant='outlined'>
					<InputLabel id='sport-label'>STATUS</InputLabel>
					<Select
						labelId='status-label'
						id='status'
						label='STATUS'
						name='status'
						value={filters.filterStatus ?? ''}
						onChange={(e): void => onChangeFilter('filterStatus', e.target.value as string)}
						className={classes.select}>
						<MenuItem value=''>
							<em>None</em>
						</MenuItem>
						<MenuItem value='NOT_SCHEDULED_WITH_MAF'>NOT_SCHEDULED_WITH_MAF</MenuItem>
						<MenuItem value='SCHEDULED_WITH_MAF'>SCHEDULED_WITH_MAF</MenuItem>
						<MenuItem value='LIVE'>LIVE</MenuItem>
					</Select>
				</FormControl>
			</Grid>
			<Grid item>
				<TextField
					id='startDate'
					label='Start Date'
					type='date'
					value={filters.filterStartDate ?? ''}
					onChange={(e): void => onChangeFilter('filterStartDate', e.target.value)}
					InputLabelProps={{
						shrink: true
					}}
					variant='outlined'
				/>
			</Grid>
			<Grid item>
				<TextField
					id='untilDate'
					label='Until Date'
					type='date'
					disabled={!filters.filterStartDate}
					value={filters.filterUntilDate ?? ''}
					onChange={(e): void => onChangeFilter('filterUntilDate', e.target.value)}
					InputLabelProps={{
						shrink: true
					}}
					variant='outlined'
				/>
			</Grid>
			{Object.keys(filters).length > 0 && (
				<Grid item>
					<Button className={classes.clearButtom} color='primary' onClick={(): void => setFilters({})}>
						clear filters
					</Button>
				</Grid>
			)}
		</Grid>
	);
};

type AiringsFiltersProps = {
	setGraphQLFilters: (filters: AiringFiltersInput) => void;
};

export type AiringFilters = {
	filterGameId?: string | null;
	filterStatus?: string | null;
	filterStartDate?: string | null;
	filterUntilDate?: string | null;
};

export type AiringFiltersInput = {
	gameId?: StringFilterInput | null;
	startTime?: StringFilterInput | null;
	status?: StringFilterInput | null;
};

export default AiringFilters;
